import { useMemo } from 'react';
import { useLegFormContext } from '@lp/features/RoutePlanner/components/RouteLegForm/context/LegFormContext';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { BaseSupplementalLiftSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { useInfinitePartnerProvidersListQuery } from '@/queries/partner-providers';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { ProviderSelect } from './ProviderSelect';

export const SupplementalProviderSelect = () => {
  const { list: partnerProvidersList } = useAsyncSearchableList({ query: useInfinitePartnerProvidersListQuery });
  const { routeType } = useLegFormContext();
  const { legs } = useRouteDetails(routeType);

  const selectedSupplementalProviderId = useMemo(() => {
    const supplementalLeg = legs.find((l) => l.legType === RouteLegTypeEnum.SupplementalLiftAviaLeg);

    return supplementalLeg?.provider.providerId || '';
  }, [legs]);

  return (
    <ProviderSelect<BaseSupplementalLiftSchemaValues>
      providerFieldName="supplementalLiftProviderId"
      providerInputTitle="Supplemental Lift Provider"
      providerList={partnerProvidersList}
      selectedSupplementalProvider={selectedSupplementalProviderId}
    />
  );
};
